import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Customizer from '../components/@vuexy/customizer/Customizer';
import VerticalSidebar from './components/menu/vertical-menu/Sidebar';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import themeConfig from '../configs/themeConfig';
import { connect } from 'react-redux';
import {
  changeNavbarColor,
  changeNavbarType,
  changeFooterType,
  changeMenuColor,
  hideScrollToTop,
  changeMode,
  collapseSidebar,
} from '../redux/actions/customizer/index';
import Feedback from '../components/shared/Feedback/Feedback';

class SharedLayout extends PureComponent {
  state = {
    width: window.innerWidth,
    sidebarState: false, // this.props.app.customizer.sidebarCollapsed,
    layout: this.props.app.customizer.theme,
    collapsedContent: false, // this.props.app.customizer.sidebarCollapsed,
    sidebarHidden: false,
    currentLang: 'en',
    appOverlay: false,
    customizer: false,
    isTouropen: false,
    currRoute: this.props.location.pathname,
    menuOpen: themeConfig.menuOpen,
  };
  collapsedPaths = [];
  mounted = false;
  updateWidth = () => {
    const { layoutMode } = this.props;
    if (
      layoutMode === 'horizontal' ||
      (layoutMode === 'vertical' && this.mounted)
    ) {
      this.setState((prevState) => ({
        width: window.innerWidth,
      }));
    }
  };

  updateScroll = () => {
    this.setState({ scroll: window.pageYOffset });
  };

  handleCustomizer = (bool) => {
    this.setState({
      customizer: bool,
    });
  };

  componentDidMount() {
    const { layoutMode } = this.props;
    this.mounted = true;

    let {
      location: { pathname },
      app: {
        customizer: { theme, direction },
      },
    } = this.props;

    if (window !== 'undefined') {
      window.addEventListener('resize', this.updateWidth, false);
      if (layoutMode === 'horizontal') {
        window.addEventListener('scroll', this.updateScroll, false);
      }
    }
    if (layoutMode === 'vertical' && this.collapsedPaths.includes(pathname)) {
      this.props.collapseSidebar(true);
    }
    if (
      layoutMode === 'horizontal' &&
      this.props.location.pathname === '/pages/profile'
    ) {
      this.setState({
        sidebarState: true,
        collapsedContent: true,
      });
    }
    let layout = theme;
    let dir = direction;
    if (layoutMode === 'vertical') {
      if (dir === 'rtl')
        document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
      else document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
    }
    return layout === 'dark'
      ? document.body.classList.add('dark-layout')
      : layout === 'semi-dark'
      ? document.body.classList.add('semi-dark-layout')
      : null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { layoutMode } = this.props;
    let {
      location: { pathname },
      app: {
        customizer: { theme, sidebarCollapsed },
      },
    } = this.props;

    let layout = theme;

    if (layoutMode === 'horizontal') {
      if (this.state.currRoute !== this.props.location.pathname) {
        this.handleRouteChange();
        this.setState({
          currRoute: this.props.location.pathname,
        });
      }
    }

    if (
      layoutMode === 'horizontal' ||
      (layoutMode === 'vertical' && this.mounted)
    ) {
      if (layout === 'dark') {
        document.body.classList.remove('semi-dark-layout');
        document.body.classList.add('dark-layout');
      } else if (layout === 'semi-dark') {
        document.body.classList.remove('dark-layout');
        document.body.classList.add('semi-dark-layout');
      } else {
        document.body.classList.remove('dark-layout', 'semi-dark-layout');
      }
    }

    if (layoutMode === 'vertical' && this.mounted) {
      if (
        prevProps.app.customizer.sidebarCollapsed !==
        this.props.app.customizer.sidebarCollapsed
      ) {
        this.setState({
          collapsedContent: sidebarCollapsed,
          sidebarState: sidebarCollapsed,
        });
      }
      if (
        prevProps.app.customizer.sidebarCollapsed ===
          this.props.app.customizer.sidebarCollapsed &&
        pathname !== prevProps.location.pathname &&
        this.collapsedPaths.includes(pathname)
      ) {
        this.props.collapseSidebar(true);
      }
      if (
        prevProps.app.customizer.sidebarCollapsed ===
          this.props.app.customizer.sidebarCollapsed &&
        pathname !== prevProps.location.pathname &&
        !this.collapsedPaths.includes(pathname)
      ) {
        //  this.props.collapseSidebar(false);
      }
    }
  }

  handleCollapsedMenuPaths = (item) => {
    let collapsedPaths = this.collapsedPaths;
    if (!collapsedPaths.includes(item)) {
      collapsedPaths.push(item);
      this.collapsedPaths = collapsedPaths;
    }
  };

  handleRouteChange = () => {
    if (this.props.location.pathname === '/pages/profile') {
      this.setState({
        collapsedContent: true,
      });
    } else {
      this.setState({
        sidebarState: false,
        collapsedContent: false,
      });
    }
  };

  toggleSidebarMenu = () => {
    this.setState({
      sidebarState: !this.state.sidebarState,
      collapsedContent: !this.state.collapsedContent,
    });
  };

  sidebarMenuHover = (val) => {
    const { layoutMode } = this.props;
    if (layoutMode === 'horizontal') {
      this.setState({
        sidebarState: !this.state.sidebarState,
      });
    } else if (layoutMode === 'vertical') {
      this.setState({
        sidebarState: val,
      });
    }
  };

  handleSidebarVisibility = () => {
    const { layoutMode } = this.props;
    if (
      layoutMode === 'horizontal' ||
      (layoutMode === 'vertical' && this.mounted)
    ) {
      if (window !== undefined) {
        window.addEventListener('resize', () => {
          if (this.state.sidebarHidden) {
            this.setState({
              sidebarHidden: !this.state.sidebarHidden,
            });
          }
        });
      }
      this.setState({
        sidebarHidden: !this.state.sidebarHidden,
      });
    }
  };

  componentWillUnmount() {
    this.mounted = false;
  }

  handleCurrentLanguage = (lang) => {
    this.setState({
      currentLang: lang,
    });
  };

  handleAppOverlay = (value) => {
    if (value.length > 0)
      this.setState({
        appOverlay: true,
      });
    else if (value.length < 0 || value === '') {
      this.setState({
        appOverlay: false,
      });
    }
  };

  handleAppOverlayClick = () => {
    this.setState({
      appOverlay: false,
    });
  };

  render() {
    const { layoutMode } = this.props;
    if (layoutMode === 'fullpage') {
      return (
        <div
          className={classnames(
            'full-layout wrapper bg-full-screen-image blank-page dark-layout',
            {
              'layout-dark': themeConfig.layoutDark,
            }
          )}
        >
          <div className="app-content">
            <div className="content-wrapper">
              <div className="content-body">
                <div className="flexbox-container">
                  <main className="main w-100">{this.props.children}</main>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    let menuThemeArr = [
      'primary',
      'success',
      'danger',
      'info',
      'warning',
      'dark',
    ];
    if (layoutMode === 'vertical') {
      let appProps = this.props.app.customizer;
      let sidebarProps = {
        toggleSidebarMenu: this.props.collapseSidebar,
        toggle: this.toggleSidebarMenu,
        sidebarState: this.state.sidebarState,
        sidebarHover: this.sidebarMenuHover,
        sidebarVisibility: this.handleSidebarVisibility,
        visibilityState: this.state.sidebarHidden,
        activePath: this.props.match.path,
        collapsedMenuPaths: this.handleCollapsedMenuPaths,
        currentLang: this.state.currentLang,
        activeTheme: appProps.menuTheme,
        collapsed: this.state.collapsedContent,
        permission: this.props.permission,
        deviceWidth: this.state.width,
      };
      let navbarProps = {
        toggleSidebarMenu: this.toggleSidebarMenu,
        sidebarState: this.state.sidebarState,
        sidebarVisibility: this.handleSidebarVisibility,
        currentLang: this.state.currentLang,
        changeCurrentLang: this.handleCurrentLanguage,
        handleAppOverlay: this.handleAppOverlay,
        appOverlayState: this.state.appOverlay,
        navbarColor: appProps.navbarColor,
        navbarType: appProps.navbarType,
      };

      let footerProps = {
        footerType: appProps.footerType,
        hideScrollToTop: appProps.hideScrollToTop,
      };

      let customizerProps = {
        customizerState: this.state.customizer,
        handleCustomizer: this.handleCustomizer,
        changeMode: this.props.changeMode,
        changeNavbar: this.props.changeNavbarColor,
        changeNavbarType: this.props.changeNavbarType,
        changeFooterType: this.props.changeFooterType,
        changeMenuTheme: this.props.changeMenuColor,
        collapseSidebar: this.props.collapseSidebar,
        hideScrollToTop: this.props.hideScrollToTop,
        activeMode: appProps.theme,
        activeNavbar: appProps.navbarColor,
        navbarType: appProps.navbarType,
        footerType: appProps.footerType,
        menuTheme: appProps.menuTheme,
        scrollToTop: appProps.hideScrollToTop,
        sidebarState: appProps.sidebarCollapsed,
      };
      return (
        <div
          className={classnames(
            `wrapper vertical-layout theme-${appProps.menuTheme}`,
            {
              'menu-collapsed':
                this.state.collapsedContent === true &&
                this.state.width >= 1200,
              'fixed-footer': appProps.footerType === 'sticky',
              'navbar-static': appProps.navbarType === 'static',
              'navbar-sticky': appProps.navbarType === 'sticky',
              'navbar-floating': appProps.navbarType === 'floating',
              'navbar-hidden': appProps.navbarType === 'hidden',
              'theme-primary': !menuThemeArr.includes(appProps.menuTheme),
            }
          )}
        >
          <VerticalSidebar {...sidebarProps} />
          <div
            className={classnames('app-content content', {
              'show-overlay': this.state.appOverlay === true,
            })}
            onClick={this.handleAppOverlayClick}
          >
            <Navbar {...navbarProps} />
            <div className="content-wrapper">{this.props.children}</div>
          </div>

          <Footer {...footerProps} />
          {appProps.disableCustomizer !== true ? (
            <Customizer {...customizerProps} />
          ) : null}
          <div
            className="sidenav-overlay"
            onClick={this.handleSidebarVisibility}
          />
        </div>
      );
    }

    let customizerProps = this.props.app.customizer;
    let navbarTypeArr = ['sticky', 'static', 'sticky', 'floating', 'hidden'];
    return (
      <div
        className={classnames(
          `wrapper horizontal-layout theme-${customizerProps.menuTheme}`,
          {
            'menu-collapsed':
              this.state.collapsedContent === true && this.state.width > 1200,
            'fixed-footer': customizerProps.footerType === 'sticky',
            'navbar-static': customizerProps.navbarType === 'static',
            'navbar-sticky': customizerProps.navbarType === 'sticky',
            'navbar-floating':
              customizerProps.navbarType === 'floating' ||
              !navbarTypeArr.includes(customizerProps.navbarType),
            'navbar-hidden': customizerProps.navbarType === 'hidden',
            'theme-primary': !menuThemeArr.includes(customizerProps.menuTheme),
          }
        )}
      >
        {/* <HorizontalSidebar
          toggleSidebarMenu={this.toggleSidebarMenu}
          sidebarState={this.state.sidebarState}
          sidebarHover={this.sidebarMenuHover}
          sidebarVisibility={this.handleSidebarVisibility}
          visibilityState={this.state.sidebarHidden}
          activePath={this.props.match.path}
          currentLang={this.state.currentLang}
          activeTheme={customizerProps.menuTheme}
          collapsed={this.state.collapsedContent}
          menuOpen={this.state.menuOpen}
          navbarType={customizerProps.navbarType}
        /> */}
        <div
          className={classnames('app-content content', {
            'show-overlay': this.state.appOverlay === true,
          })}
          onClick={this.handleAppOverlayClick}
        >
          <Navbar
            horizontal
            scrolling={this.state.scroll > 50 ? true : false}
            toggleSidebarMenu={this.toggleSidebarMenu}
            sidebarState={this.state.sidebarState}
            sidebarVisibility={this.handleSidebarVisibility}
            currentLang={this.state.currentLang}
            changeCurrentLang={this.handleCurrentLanguage}
            handleAppOverlay={this.handleAppOverlay}
            appOverlayState={this.state.appOverlay}
            navbarColor={customizerProps.navbarColor}
            navbarType={customizerProps.navbarType}
          />
          <div className="content-wrapper">{this.props.children}</div>
          <Feedback />
        </div>

        <Footer
          footerType={customizerProps.footerType}
          hideScrollToTop={customizerProps.hideScrollToTop}
        />
        {customizerProps.disableCustomizer !== true ? (
          <Customizer
            scrollToTop={customizerProps.hideScrollToTop}
            activeNavbar={customizerProps.navbarColor}
            activeMode={customizerProps.theme}
            navbarType={customizerProps.navbarType}
            footerType={customizerProps.footerType}
            menuTheme={customizerProps.menuTheme}
            customizerState={this.state.customizer}
            handleCustomizer={this.handleCustomizer}
            changeNavbar={this.props.changeNavbarColor}
            changeNavbarType={this.props.changeNavbarType}
            changeFooterType={this.props.changeFooterType}
            changeMenuTheme={this.props.changeMenuColor}
            hideScrollToTop={this.props.hideScrollToTop}
            changeMode={this.props.changeMode}
          />
        ) : null}
        <div
          className="sidenav-overlay"
          onClick={this.handleSidebarVisibility}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    app: state.customizer,
  };
};
export default connect(mapStateToProps, {
  changeMode,
  collapseSidebar,
  changeNavbarColor,
  changeNavbarType,
  changeFooterType,
  changeMenuColor,
  hideScrollToTop,
})(SharedLayout);
